import { fetchJson } from '../../apiBase';

export const STAFF_LISTENING_CONTRACT = 'school-life-staff-review-v1';

async function request(path, body, context) {
  const response = await fetchJson(path, {
    method: 'POST', signal: context.signal, cache: 'no-store',
    headers: { 'Content-Type': 'application/json', ...(context.staffSchoolId ? {} : {
      'X-Mini-Task-Session': context.boardSessionId,
      ...(context.boardToken ? { 'X-Mini-Task-Board-Token': context.boardToken } : {}),
    }) },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    const error = new Error('Question audio could not be loaded.');
    error.code = payload?.detail?.code;
    error.retryable = payload?.detail?.retryable === true || response.status >= 500;
    throw error;
  }
  return response;
}

function pathFor(roundId, questionId, context) {
  if (context.staffSchoolId && context.staffQuestionKey) {
    return `/admin/mini-tasks/${encodeURIComponent(context.staffSchoolId)}/content-qa/73/questions/${encodeURIComponent(context.staffQuestionKey)}/listening`;
  }
  return `/mini-tasks/rounds/${encodeURIComponent(roundId)}/questions/${encodeURIComponent(questionId)}/listening`;
}

export async function issueListening(roundId, questionId, action, context) {
  return (await request(pathFor(roundId, questionId, context), { action }, context)).json();
}

export async function listeningBytes(roundId, questionId, asset, context) {
  const response = await request(`${pathFor(roundId, questionId, context)}/bytes`, { handle: asset.handle }, context);
  const blob = await response.blob();
  if (blob.type !== asset.mime_type || blob.size === 0 || blob.size > 5000000) {
    const error = new Error('Question audio could not be loaded.');
    error.retryable = true;
    throw error;
  }
  return blob;
}

export async function scoreListeningAnswer(roundId, questionId, selectedAnswer, context) {
  if (context.staffSchoolId) throw new Error('Staff preview answers are checked locally.');
  const result = await (await request(`${pathFor(roundId, questionId, context)}/answer`, { selected_answer: selectedAnswer }, context)).json();
  if (typeof result.is_correct !== 'boolean' || typeof result.correct_answer !== 'string' || !result.feedback?.message) {
    throw new Error('The answer could not be checked.');
  }
  return result;
}
